import { Component, OnInit, ViewChild } from '@angular/core';
import { RequestService } from '../../../../services/request.service';
import { environment } from '../../../../environments/environment';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Router, ActivatedRoute } from "@angular/router";
import { DataTableDirective } from 'angular-datatables';
import { from, Subject } from 'rxjs';
import { DatePipe } from '@angular/common';
declare var $: any;

@Component({
  selector: 'app-user-feedback-report',
  templateUrl: './user-feedback-report.component.html',
  styleUrls: ['./user-feedback-report.component.scss']
})
export class UserFeedbackReportComponent implements OnInit {

  @ViewChild(DataTableDirective, { static: false })
  dtElement: DataTableDirective;
  dtOptions: any = {};
  // dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject();

  constructor(
    private request: RequestService,
    private http: HttpClient,
    private router: Router,
    private datePipe: DatePipe
  ) { }
  ufdForm: any = {};

  roleId=0;
  ngOnInit(): void {
    const today = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
    this.roleId = Number(localStorage.getItem('roleId'));
    // const today = new Date().toISOString().substring(0, 10); 
    this.ufdForm = {
      fromDate: today,
      toDate: today,
      device_id: null
    }
    this.ViewToilets();
    this.DevicesFeedback();
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
      processing: true,
      dom: 'Bfrtip',
      buttons: [
        {
          extend: 'csv',
          text: '<i class="fa fa-file-text-o"></i>',
          titleAttr: 'Download as CSV',
          title: 'Device Master'
        },
        {
          extend: 'excel',
          text: '<i class="fa fa-file-excel-o"></i>',
          titleAttr: 'Download as Excel',
          title: 'Device Master'
        },
        {
          extend: 'pdf',
          text: '<i class="fa fa-file-pdf-o"></i>',
          titleAttr: 'Download as Pdf',
          title: 'Device Master'
        }
      ]
    };
  }


  ShowReport() {
    let fromDate = this.datePipe.transform($("#dateTime").val(), "yyyy-MM-dd") + " 00:00:00";
    let toDate = this.datePipe.transform($("#toDate").val(), "yyyy-MM-dd") + " 23:59:59";
    // let fromDate = dateTime + "  00:00:00";
    // let toDate = dateTime + " 23:59:59";
    // console.log(fromDate + " :: " + toDate);
  }

  rowData: any;
  deviceData = [];
  isLoading = false;
  async DevicesFeedback() {
    try {
      this.isLoading = true;
      this.deviceData = [];
      const requestData = {};
      this.dtTrigger = new Subject<any>();
      const data: any = await this.request.post('/dashboard/view_toilet_feedback_log_data', requestData);
      this.dtTrigger.next();
      for (let objKey of Object.keys(data.result)) {
        let dataObj = data.result[objKey];
        this.deviceData.push(dataObj);
      }
      this.rowData = this.deviceData;
      // console.log(this.rowData);
      this.isLoading = false;
    } catch (error) { }
  }


  toiletData = [];
  deviceDataArr = [];
  async ViewToilets() {
    try {
      this.toiletData = [];
      const device = {
        'toilet_id': 0,
      };
      const data: any = await this.request.post('/master/view_toilet', device);
      for (let objKey of Object.keys(data)) {
        let dataObj = data[objKey];
        if (objKey == "result") {
          for (let objKey1 of Object.keys(dataObj)) {
            let arr = {
              id: dataObj[objKey1].device_id,
              deviceLabel: `${dataObj[objKey1].device_id}:${dataObj[objKey1].address}(Zone -${dataObj[objKey1].zone_id}, Ward -${dataObj[objKey1].ward_id})`
            };
            // console.log(arr);
            this.toiletData.push(arr);
          }
        }
      }
      this.deviceDataArr = this.toiletData;
      console.log(this.deviceDataArr);
    } catch (error) { }
  }


  deviceLog = [];
  async FeedbackDetailReport() {
    try {
      this.isLoading = true;
      this.deviceLog = [];
      const today = this.datePipe.transform(new Date(), "yyyy-MM-dd");
      let fromDate = this.datePipe.transform(this.ufdForm.fromDate || today, "yyyy-MM-dd") + " 00:00:00";
      let toDate = this.datePipe.transform(this.ufdForm.toDate || today, "yyyy-MM-dd") + " 23:59:59";
      const requestData = {
        'from_date': fromDate,
        'to_date': toDate,
        'deviceId': this.ufdForm.device_id
      };
      // console.log(requestData);
      // this.dtTrigger = new Subject<any>();
      const data: any = await this.request.post('/dashboard/view_toilet_feedback_log_data_details', requestData);
      // console.log(data);
      for (let objKey of Object.keys(data.result)) {
        let dataObj = data.result[objKey];
        this.deviceLog.push(dataObj);
      }
      // console.log(this.deviceLog);
      this.rowData = this.deviceLog;
      this.rowData.sort(function (a, b) {
        if (a.log_date_time < b.log_date_time) {
          return 1;   // changed
        }
        if (a.log_date_time > b.log_date_time) {
          return -1;  // changed
        }
        return 0;
      });

      this.applyFeedbackFilter();

      $('#feedbackTable').DataTable().destroy();
      this.dtTrigger.next();
      this.isLoading = false;
    } catch (error) { }

  }

  selectedFeedback: string = 'ALL';
  applyFeedbackFilter() {
    if (this.selectedFeedback === 'ALL') {
      this.rowData = [...this.deviceLog];
    } else {
      this.rowData = this.deviceLog.filter(
        item => item.feedback === this.selectedFeedback
      );
    }

    // Re-render datatable
    // $('#feedbackTable').DataTable().destroy();
    //this.dtTrigger.next();
  }


  public deviceBarChartData: any = [];
  public deviceBarChartLabels: any = [];
  public deviceBarChartOptions: any = {
    responsive: true,
    scales: {
      xAxes: [{
        ticks: {
          autoSkip: true,
          maxRotation: 45,
          minRotation: 0
        },
        scaleLabel: {
          display: true,
          labelString: 'Device'
        }
      }],
      yAxes: [{
        ticks: {
          beginAtZero: true,
          stepSize: 10,
        },


        scaleLabel: {
          display: false,
          labelString: 'Feedback'
        }
      }]
    },
    legend: {
      position: 'top',
      display: true
    },
    tooltips: {
      mode: 'index',
      intersect: false
    }
  };
  public deviceBarChartColors: any = [
    {
      backgroundColor: 'rgba(63,81,181,0.2)',
      borderColor: 'rgba(63,81,181,1)',
      pointBackgroundColor: 'rgba(63,81,181,1)',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgba(63,81,181,1)'
    }
  ];
  public deviceBarChartLegend = true;
  public deviceBarChartType = 'line';


  chartClickedDevicewise(e) {
    if (e.active.length > 0) {
      const chart = e.active[0]._chart;
      const activePoints = chart.getElementAtEvent(e.event);
      if (activePoints.length > 0) {
        // get the internal index of slice in pie chart
        const clickedElementIndex = activePoints[0]._index;
        const label = chart.data.labels[clickedElementIndex];
        // get value by index
        console.log(chart.data.datasets);
        const value = chart.data.datasets[0].data[clickedElementIndex];
        const labelValue = chart.data.datasets[0].label;

      }
    }
  }


  async getHourlyDataDevicewise(device_id) {
    const Data = {
      'action': "view_person_count_devicewise_hourly",
      'device_id': device_id
    };
    //console.log(data);
    this.deviceBarChartData = [];
    this.deviceBarChartLabels = [];
    try {
      const response: any = await this.request.post('', Data);
      console.log(response);
      if (response && response.status) {
        const result = response.result;
        // console.log(result);
        this.deviceBarChartLabels = result.map(item => item.time);
        this.deviceBarChartData = [
          {
            data: result.map(item => item.feedback_status),
            label: 'Feedback Detail'
          }
        ];
      } else {
        console.error('Error in response:', response.message);
      }
    } catch (error) {
      console.error('Error fetching hourly data:', error);
    }
  }


  //contact detail
  selectedDeviceData: any = {};
  async ShowContactDetail(device_id: string) {
    try {
      console.log(" Fetching Details for Device ID:", device_id);

      this.selectedDeviceData = this.rowData.find(
        (item: any) => String(item.device_id) === String(device_id)
      );

      console.log("Selected Device Data:", this.selectedDeviceData);

      ($('#contactModal') as any).modal('show');
    } catch (error) {
      console.error(" Error in ShowContactDetail:", error);
    }

  }

  selectedSmsType: string = '';
  isUpdatedRecord:any="";
  message:any="";
  async sendSmsNotification() {
    try{
      if (!this.selectedSmsType) {
        alert('Please select SMS Type.');
        return;
      }
      const payload = {
        deviceId: this.selectedDeviceData.device_id,
        smsType: this.selectedSmsType
      };
      console.log(payload);
      
      const save: any = await this.request.post('/dashboard/update_live_device_status',payload);
      for (let objKey of Object.keys(save)) {
        let dataObj = save[objKey];
        if(objKey=="status"){
        this.isUpdatedRecord = save[objKey];
        }
        if(objKey=="message"){
        this.message = save[objKey];
        }
      }
      if (this.isUpdatedRecord=="SUCCESS") {
        // alert("Save Successfully");
        const result = await Swal.fire({
        title: 'Successfully Save',
        text: 'Saved Changes.',
        type: 'success',
        showConfirmButton: false,  
        timer: 1500
        // confirmButtonText: 'Ok'
        });
        if (result.value) {
        // Form Reset
        window.location.reload();
        // this.closeModal();
        // this.DevicesFeedback();
        }
        window.location.reload();
        // this.closeModal();
        // this.DevicesFeedback();
      } else{
        const result = await Swal.fire({
          title: "Oops ?",
          text: this.message,   
          type: "warning",   
          showCancelButton: false,      
          confirmButtonColor: "#FF0000",   
          confirmButtonText: "Close",   
          closeOnConfirm: false,   
          closeOnCancel: false,
          customClass: "Custom_Cancel"
        });
      }
    }catch(error){}
  }

  closeModal() {
    $('#contactModal').modal('hide');
  }
  closeModal1() {
    $('#contactModal').modal('hide');
  }

}


